import React, {useState} from 'react';
import {Modal} from "../../../../../../components/modal/modal.jsx";
import Button from "../../../../../../components/button/button.jsx";
import IndividualFilterTabs from "./individual-filter-tabs.jsx";
import GeneralFilter from "./general-filter.jsx";
import CharacteristicsFilter from "./characteristics-filter.jsx";
import AddressesFilter from "./addresses-filter.jsx";
import OtherInformationFilter from "./other-information-filter.jsx";
import OtherFilters from "./other-filters.jsx";
import {Card} from "../../../../../../components/card/card.jsx";

const IndividualFilter = ({open, setOpen, filter, setFilter, onSearch}) => {
    const [tabSelected, setTabSelected] = useState("general")

    const onChange = ({target: {id, value}}) => setFilter(prev => ({...prev, [id]: value}));

    const onChangeCustom = (value, id) => setFilter(prev => ({...prev, [id]: value}));

    const search = () => {
        onSearch()
        setOpen(false)
    }

    return (
        <Modal isCloseClick={false} overflow={true} open={open} setOpen={() => setOpen(false)}  title={"Filtros avançados"} className={"w-8/12"} alignTop={true}>

            <Modal.Body className="p-2">
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-3">
                        <IndividualFilterTabs
                            tabSelected={tabSelected}
                            setTabSelected={setTabSelected}
                        />
                    </div>
                    <div className="col-span-9">
                        <Card>
                            <Card.Body className={"h-[264px]"}>
                                {
                                    tabSelected === "general" &&
                                    <GeneralFilter
                                        filter={filter}
                                        onChange={onChange}
                                        onChangeCustom={onChangeCustom}
                                    />
                                }

                                {
                                    tabSelected === "characteristics" &&
                                    <CharacteristicsFilter
                                        filter={filter}
                                        onChange={onChange}
                                        onChangeCustom={onChangeCustom}
                                    />
                                }

                                {
                                    tabSelected === "addresses" &&
                                    <AddressesFilter
                                        filter={filter}
                                        onChange={onChange}
                                        onChangeCustom={onChangeCustom}
                                    />
                                }

                                {
                                    tabSelected === "other-information" &&
                                    <OtherInformationFilter
                                        filter={filter}
                                        onChange={onChange}
                                        onChangeCustom={onChangeCustom}
                                    />
                                }

                                {
                                    tabSelected === "others" &&
                                    <OtherFilters
                                        filter={filter}
                                        onChange={onChange}
                                        onChangeCustom={onChangeCustom}
                                    />
                                }
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className={"p-2"}>
                <div className="w-full flex justify-end m-0">
                    <Button onClick={search}>Pesquisar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default IndividualFilter;
